import { api, ApiError } from '@/lib/api';
import type { SourceCoverage } from '@waypoint/shared';

export interface CashRunwayWeek {
  weekStart: string;
  weekLabel: string;
  inflowCents: number;
  outflowCents: number;
  netCents: number;
  cumulativeCents: number;
  components: {
    arDueCents: number;
    arOverdueCents: number;
    dealCloseCents: number;
  };
}

export interface CashRunwayResult {
  /** The inflow figures (and the crunch week) are null without a connected, synced accounting/payments source. */
  weeks: CashRunwayWeek[] | null;
  startingCashCents: number | null;
  weeklyExpenseCents: number;
  weeksUntilCrunch: number | null;
  totalInflow13wCents: number | null;
  narrative: string | null;
  coverage?: SourceCoverage;
}

/** Returned when the accounting integration (QBO / Stripe) isn't connected yet. */
const NOT_CONNECTED: CashRunwayResult = {
  weeks: [],
  startingCashCents: null,
  weeklyExpenseCents: 0,
  weeksUntilCrunch: null,
  totalInflow13wCents: null,
  narrative: 'Connect QuickBooks or Stripe to unlock the cash runway forecast.',
};

export async function getCashRunway(): Promise<CashRunwayResult> {
  try {
    return await api('/v1/cash-runway');
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return NOT_CONNECTED;
    throw err;
  }
}
